/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { ReactElement } from "react";
import { WatchSEO } from "components";
import { WatchProps } from "screens/Watch";

const Watch = dynamic(() => import("screens/Watch/Watch"));

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const setCacheHeader = await import("helpers/cacheHeaderHelper").then(
    (mod) => mod.setCacheHeader
  );
  setCacheHeader(ctx.res);
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps } = await getCommonServerSideProps(ctx);

  return {
    props: { ...commonProps },
  };
};

const WatchWrapper = (props: WatchProps) => {
  return (
    <>
      <WatchSEO />
      <Watch {...props} />
    </>
  );
};

WatchWrapper.getLayout = function getLayout(page: ReactElement) {
  return page;
};

export default WatchWrapper;
